import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { CardPopupWrapper } from './CardPopupWrapper';

const messages = defineMessages({
	errorTitle: {
		id: 'user-profile-card.error.title',
		defaultMessage: "Something went wrong and we couldn't load this profile.",
		description: 'Title when the user profile card fails to load',
	},
	errorDescription: {
		id: 'user-profile-card.error.description',
		defaultMessage: 'Try again in a few moments.',
		description: 'Supporting text when the user profile card fails to load',
	},
});

const styles = cssMap({
	body: {
		paddingTop: token('space.300'),
		paddingBottom: token('space.300'),
		paddingLeft: token('space.300'),
		paddingRight: token('space.300'),
		textAlign: 'center',
	},
});

/**
 * Error fallback when the entry point fails to render or profile data is missing.
 */
export function CardError({ testId }: { testId?: string }): React.JSX.Element {
	const intl = useIntl();

	return (
		<CardPopupWrapper>
			<Box testId={testId} role="alert">
				<Stack space="space.100" xcss={styles.body}>
					<Text weight="semibold" color="color.text.subtlest">
						{intl.formatMessage(messages.errorTitle)}
					</Text>
					<Text size="small" color="color.text.subtlest">
						{intl.formatMessage(messages.errorDescription)}
					</Text>
				</Stack>
			</Box>
		</CardPopupWrapper>
	);
}
